import { query, request } from '@/utils/request';
// 工作考核列表查询
export async function getWorkAssessmentList(data) {
  return query('/zlb/api/office/work/assessment/list', {
    method: 'POST',
    data,
  });
}
//工作考核列表详情
export async function getWorkAssessmentDetail(data) {
  return query('/zlb/api/office/work/assessment/detail', {
    method: 'POST',
    data,
  });
}
// 新建/编辑工作考核
export async function saveWorkAssessment(data) {
  return query('/zlb/api/office/work/assessment/save', {
    method: 'POST',
    data,
  });
}
// 工作考核 操作方式 开启/结束/驳回
export async function operateWorkAssessment(data) {
  return query('/zlb/api/office/work/assessment/operate', {
    method: 'POST',
    data,
  });
}
// 工作考核数据统计分布
export async function getWorkAssessmentAnalysisData(data) {
  return query('/zlb/api/office/work/assessment/data/analysis', {
    method: 'POST',
    data,
  });
}
// 导入考核人员关系
export async function importWorkAssessment(params) {
  return query('/zlb/api/office/work/assessment/import', {
    method: 'GET',
    params,
  });
}
//导出
export async function exportWorkAssessment(params) {
  return query('/zlb/api/office/work/assessment/export', {
    method: 'GET',
    params,
  });
}
//工作考核明细列表
export async function getWorkAssessmentInfoList(data) {
  return query('/zlb/api/office/work/assessment/info/list', {
    method: 'POST',
    data,
  });
}
//工作考核 删除
export async function deleteWorkAssessment(data) {
  return query('/zlb/api/office/work/assessment/delete', {
    method: 'POST',
    data,
  });
}

//考核明细 导入任务提交
export async function submitWorkAssessmentResult(data) {
  return query('/zlb/api/office/work/assessment/import/submit', {
    method: 'POST',
    data,
  });
}
//根据任务序列号查询任务结果
export async function getImportWorkAssessmentResult(params) {
  return query('/zlb/api/office/work/assessment/import/result', {
    method: 'GET',
    params,
  });
}
// 打印 &下载任务进度轮询接口
export const queryTask = async data => {
  return request('/zlb/api/expense/print/task-query', {
    method: 'POST',
    data,
  });
};
//列表查询 考核人视角
export async function getOfficeWorkAssessmentInfoList(data) {
  return query('/zlb/api/office/work/summary/list/assessment', {
    method: 'POST',
    data,
  });
}
// 下载模版
export async function importTemplateWorkAssessment() {
  return request('/zlb/api/office/work/assessment/import/template', {});
}

//工作考核明细列表
export async function getOfficeWorkSummaryList(data) {
  return query('/zlb/api/office/work/summary/list', {
    method: 'POST',
    data,
  });
}
// 列表查询 考核人视角 考核明细
export async function getOfficeWorkAssessmentSummaryList(data) {
  return query('/zlb/api/office/work/summary/info/list/assessment', {
    method: 'POST',
    data,
  });
}
// 提交考核
export async function submitOfficeWorkSummary(data) {
  return query('/zlb/api/office/work/summary/submit', {
    method: 'POST',
    data,
  });
}
// 列表查询 考核人考核
export async function auditOfficeWorkSummary(data) {
  return query('/zlb/api/office/work/summary/audit', {
    method: 'POST',
    data,
  });
}
// 提交考核
export async function submitOfficeWorkAssessment(data) {
  return query('/zlb/api/office/work/assessment/submit', {
    method: 'POST',
    data,
  });
}
